// Original procedural composition: warm, softly plucked Cmaj7 / Am7 / Fmaj7 / G6.
// Karplus–Strong synthesis, no recordings, external requests, or third-party music.
export class FocusAudio {
  constructor() {
    this.volume = 0.35
    this.playing = false
  }
  async unlock() {
    if (!this.context) {
      this.context = new (window.AudioContext || window.webkitAudioContext)()
      this.gain = this.context.createGain()
      this.gain.gain.value = 0
      const filter = this.context.createBiquadFilter()
      filter.type = 'lowpass'
      filter.frequency.value = 2600
      this.gain.connect(filter)
      filter.connect(this.context.destination)
    }
    if (this.context.state !== 'running') await this.context.resume()
  }
  prepare() {
    if (this.source) return
    const rate = this.context.sampleRate
    const seconds = 32
    const buffer = this.context.createBuffer(2, rate * seconds, rate)
    const chords = [
      [48, 55, 59, 64],
      [45, 52, 55, 60],
      [41, 48, 52, 57],
      [43, 50, 55, 59],
    ]
    let seed = 812
    const random = () => {
      seed = (seed * 1664525 + 1013904223) >>> 0
      return seed / 4294967296
    }
    for (let beat = 0; beat < 64; beat++) {
      const notes = chords[Math.floor(beat / 16)]
      const midi = notes[[0, 2, 1, 3, 0, 1, 2, 3][beat % 8]]
      const frequency = 440 * 2 ** ((midi - 69) / 12)
      const period = Math.round(rate / frequency)
      const string = Float32Array.from(
        { length: period },
        () => (random() * 2 - 1) * 0.22,
      )
      const start = Math.floor(beat * 0.5 * rate)
      for (let i = 0; i < rate * 3; i++) {
        const pos = i % period
        const value = string[pos]
        string[pos] = 0.497 * (value + string[(pos + 1) % period])
        const sample = (start + i) % buffer.length
        const envelope = Math.min(1, i / (rate * 0.012))
        buffer.getChannelData(0)[sample] +=
          value * envelope * (beat % 2 ? 0.8 : 1)
        buffer.getChannelData(1)[sample] +=
          value * envelope * (beat % 2 ? 1 : 0.8)
      }
    }
    this.source = this.context.createBufferSource()
    this.source.buffer = buffer
    this.source.loop = true
    this.source.connect(this.gain)
    this.source.start()
  }
  setPlaying(playing, volume = this.volume) {
    this.volume = volume
    this.playing = playing
    if (!this.context) return
    if (playing) this.prepare()
    const at = this.context.currentTime
    this.gain.gain.cancelScheduledValues(at)
    this.gain.gain.setTargetAtTime(playing ? volume * 0.8 : 0, at, 0.25)
  }
  chime() {
    if (!this.context || this.context.state !== 'running') return
    ;[659.25, 783.99].forEach((frequency, i) => {
      const oscillator = this.context.createOscillator(),
        gain = this.context.createGain()
      const at = this.context.currentTime + i * 0.2
      oscillator.frequency.value = frequency
      gain.gain.setValueAtTime(0, at)
      gain.gain.linearRampToValueAtTime(0.07, at + 0.015)
      gain.gain.exponentialRampToValueAtTime(0.001, at + 0.9)
      oscillator.connect(gain)
      gain.connect(this.context.destination)
      oscillator.start(at)
      oscillator.stop(at + 1)
    })
  }
}
